module.exports = __webpack_public_path__ + "img/badge-geography.5f5ee30d.svg";